import React from 'react';
import { Drawer, IconButton, Box, useTheme } from '@mui/material';
import { Close } from '@mui/icons-material';
import FilterSidebar from './FilterSidebar';

const FilterDrawer = ({ open, onClose, onApply, onClear }) => {
  const theme = useTheme();

  return (
    <Drawer
      anchor="left"
      open={open}
      onClose={onClose}
      sx={{
        '& .MuiDrawer-paper': {
          width: '280px',
          p: 2,
          backgroundColor: theme.palette.background.paper,
        },
      }}
    >
      <Box display="flex" justifyContent="flex-end">
        <IconButton onClick={onClose}>
          <Close />
        </IconButton>
      </Box>
      <FilterSidebar 
        onApply={(filters) => {
          onApply(filters);
          onClose();
        }} 
        onClear={onClear}
      />
    </Drawer>
  );
};

export default FilterDrawer;